import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

const RoleListItem = (props) => {
  const { role: { id, title } } = props

  return (
    <DashboardModuleListItem title={title}>
      <DashboardModuleListItem.TertiaryText>
        # {id}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

RoleListItem.propTypes = {
  role: PropTypes.object.isRequired,
}

export default RoleListItem
